import { useContext } from 'react';

import { ContextType, PresentationPreferenceContext } from '../../components/PresentationContext/PresentationContext';

export const usePresentationPreference = (): ContextType => {
  const context = useContext(PresentationPreferenceContext);

  if (!context) {
    return {
      obfuscateAi: false,
    };
  }

  return context;
};
